/** Thrown by {@link confirmGcpServiceDate} when the pilot backs out of the date confirmation modal. */
export class GcpServiceDateCancelledError extends Error {
  constructor() {
    super('GCP service date confirmation was cancelled');
    this.name = 'GcpServiceDateCancelledError';
  }
}

export const isGcpServiceDateCancelledError = (e: unknown): e is GcpServiceDateCancelledError =>
  e instanceof GcpServiceDateCancelledError;
